import axios from 'axios';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import { FETCH_TRACKING_ID } from '../actionTypes';
import { prepareServiceConfig } from '../utils/sagaUtils';
import { setWarningsOrErrors } from '../app/appActions';

export function* fetchTrackingId() {
  try {
    const isStubbed = yield select(state => state.app.isStubbed);
    const serviceConfig = yield select(
      state => state.configurations.serviceConfig
    );

    const config = prepareServiceConfig(
      serviceConfig.trackingId,
      serviceConfig.trackingId.url,
      {
        'X-HSBC-Chnl-CountryCode': 'HK',
        'X-HSBC-Channel-Id': 'Web',
        'X-HSBC-Locale': 'en_HK',
        'X-HSBC-Chnl-Group-Member': 'HBAP',
        Token_Type: 'SESSION_TOKEN'
      },
      isStubbed ? 'GET' : 'POST'
    );

    const {
      data: { trackingID }
    } = yield call(axios, config);

    if (trackingID) {
      window.sessionStorage.setItem('application_cin', trackingID);
    }
  } catch (error) {
    yield put(
      setWarningsOrErrors({
        errors: [{ errorCode: 'UI0001', causes: 'tracking id saga failed' }]
      })
    );
  }
}

export default function* trackingSaga() {
  yield takeEvery(FETCH_TRACKING_ID, fetchTrackingId);
}
